﻿window.cFuncEnvoiEmailSms = function () {

    function mExeSendEmailSms(option) {
        var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
            showMaximize: false,
            height: "auto",
            width: 500,
            hideOnOutsideClick: true,
            shading: true,
            title: option.title,
            contentTemplate: function (contentElement) {
                contentElement.css("padding-top", "10px")
                var dx = null
                switch (option.type) {
                    case "email":
                        dx = $("<div/>").appendTo(contentElement).dxCtrlTextEmail({
                            labelMode: 'floating',
                            label: "Adresse email",
                            width: "100%",
                            mode: "email",
                            value: option.value,
                            onContentReady: function (e) {
                                window.setTimeout(function () { dx.focus() }, 500)
                            }
                        }).dxCtrlTextEmail("instance")

                        if (parametre.isDesktop && option.keyParaAppli && option.keyParaAppli.length > 0) {
                            var $A = $("<div style='padding:10px;opacity:0.6;text-align:right;'><a href='javascript:void(0)'>Modifier le modèle d'email</a></div>").appendTo(contentElement)
                            $A.on("click", function () {
                                pop.hide()
                                $("<div/>").appendTo("body").dxCtrlParaAppli({
                                    selectedKey: option.keyParaAppli,
                                    bddCtrl: option.bddCtrl,
                                    isInPopup: true
                                })
                            })
                        }
                        mAddButtonOkAnnuler(contentElement,
                            function () { //ok
                                if (!dx.hasErreur && dx.option("value") != null && dx.option("value").length > 0) {
                                    option.open = false
                                    option.onValide(dx.option("value"))
                                    pop.hide();
                                } else {
                                    mNotify("Veuillez saisir une adresse email.", "warning", 6000);
                                    dx.focus()
                                }
                            },
                            function () { //annuler
                                pop.hide();
                            }, "Annuler", "Envoyer",
                            (option.bddCtrl.objCptCli.objetMetier.hasEmail() ? function () {
                                if (!dx.hasErreur && dx.option("value") != null && dx.option("value").length > 0) {
                                    option.open = true
                                    option.onValide(dx.option("value"))
                                    pop.hide();
                                } else {
                                    mNotify("Veuillez saisir une adresse email.", "warning", 6000);
                                    dx.focus()
                                }
                            } : null), (option.bddCtrl.objCptCli.objetMetier.hasEmail() ? "Ouvrir" : null)).table.css("margin-top", "20px")
                        break;
                    case "sms":
                        $("<div style='margin-bottom:10px;'/>").appendTo(contentElement).dxTextArea({
                            labelMode: 'floating',
                            label: "Message SMS (l'url du document sera rajoutée à la suite du message)",
                            value: option.messagesms,
                            onValueChanged: function (e) {
                                option.messagesms = (!e.value ? "" : e.value)
                                option.bddCtrl.utiCourantParaJson[option.keyParaJson] = option.messagesms
                                option.bddCtrl.mSaveParaJsonUtilisateur()
                            }
                        })
                        dx = $("<div/>").appendTo(contentElement).dxCtrlTelephone({
                            labelMode: 'floating',
                            label: "N° de mobile",
                            typeTel: "mob",
                            value: option.value,
                            onContentReady: function (e) {
                                window.setTimeout(function () { dx.focus() }, 500)
                            }
                        }).dxCtrlTelephone("instance");
                        mAddButtonOkAnnuler(contentElement,
                            function () { //ok
                                if (dx.hasValue()) {
                                    option.onValide(dx.option("value"))
                                    pop.hide();
                                } else {
                                    mNotify("Veuillez saisir un numéro de mobile.", "warning", 6000);
                                    dx.focus()
                                }
                            },
                            function () { //annuler
                                pop.hide();
                            }, "Annuler", "Envoyer").table.css("margin-top", "20px")
                        break;
                }
            }
        }).dxCtrlPopupBase("instance")
        pop.show()
    }

    this.mDemandeSendEmailSmsDocCpt = function (option) {
        var onvalide = option.onValide
        option.onValide = function (value) {
            switch (option.type) {
                case "email":
                    if (!option.docCptDetail.docCptClient.adresse_email || option.docCptDetail.docCptClient.adresse_email.length == 0) {
                        option.docCptDetail.docCptClient.adresse_email = value
                        option.bddCtrl.getObjet(option.docCptDetail.docCptClient).mSaveChamp("adresse_email")
                        if (option.onValueChanged) option.onValueChanged()
                    }
                    jaugeDemarrage.mShow()
                    option.docCptDetail.mGetUrlPdfDocCpt(option.formatPrint,function (urlPdf) {
                        if (option.bddCtrl.objCptCli.objetMetier.hasEmail()) {
                            var lstDest = []
                            if (option.docCptDetail.docCptClient.id) {
                                var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.docCptDetail.docCptClient.id_table).nom, option.docCptDetail.docCptClient.id)
                                var adrEmail = obj.objetMetier.mGetAdresseEmailDefaut()
                                if (adrEmail == value) {
                                    lstDest = [{ id_table: option.docCptDetail.docCptClient.id_table, id: option.docCptDetail.docCptClient.id, adresse_email: value }]
                                } else {
                                    lstDest = [{ id_table: null, id: null, adresse_email: value }]
                                }
                            } else {
                                lstDest = [{ id_table: null, id: null, adresse_email: value }]
                            }
                            option.bddCtrl.getObjet("com_email_envoi").objetMetier.mCreateEmailBrouillon(
                                "", "", [urlPdf],
                                lstDest,
                                option.bddCtrl.paraAppli.mGetPara(option.keyParaAppli),
                                true, null, false, null, false, "", function (idComEmailEnvoi) {
                                    if (option.open) {
                                        option.bddCtrl.getObjet("com_email_envoi", idComEmailEnvoi).mShowPopup()
                                        jaugeDemarrage.mHide()
                                    } else {
                                        option.bddCtrl.getObjet("com_email_envoi", idComEmailEnvoi).objetMetier.mSendImmediatement()
                                        jaugeDemarrage.mHide()
                                        mNotify("Un email avec le document joint a été envoyé à <a>" + value + "</a>", "success", 8000)
                                    }
                                    if (option.onEndSend) option.onEndSend()
                                })
                        } else {
                            option.bddCtrl.mAjaxCall({
                                command: "sendemailmessageclient",
                                adresse_email: value,
                                keyparasignature: option.keyParaAppli,
                                url_file_join_relatif: urlPdf
                            }, function (data) {
                                jaugeDemarrage.mHide()
                                mNotify("Un email avec le document joint a été envoyé à <a>" + value + "</a>", "success", 8000)
                                if (option.onEndSend) option.onEndSend()
                            })
                        }
                    })
                    break;
                case "sms":
                    if (!option.docCptDetail.isValidated()) {
                        if (value.tel_num_type == "0") { //fixe
                            if (!option.docCptDetail.docCptClient.tel_sms || option.docCptDetail.docCptClient.tel_sms.length > 0) {
                                option.docCptDetail.docCptClient.tel_code_pays = value.tel_code_pays
                                option.docCptDetail.docCptClient.tel_number = value.tel_number
                                option.docCptDetail.docCptClient.tel_complet = value.tel_complet
                                option.docCptDetail.docCptClient.tel_sms = value.tel_sms
                                option.docCptDetail.docCptClient.tel_error = value.tel_error
                                option.docCptDetail.docCptClient.tel_num_type = value.tel_num_type
                                option.bddCtrl.getObjet(option.docCptDetail.docCptClient).mSave()
                                if (option.onValueChanged) option.onValueChanged()
                            }
                        } else {
                            if (!option.docCptDetail.docCptClient.mob_sms || option.docCptDetail.docCptClient.mob_sms.length > 0) {
                                option.docCptDetail.docCptClient.mob_code_pays = value.tel_code_pays
                                option.docCptDetail.docCptClient.mob_number = value.tel_number
                                option.docCptDetail.docCptClient.mob_complet = value.tel_complet
                                option.docCptDetail.docCptClient.mob_sms = value.tel_sms
                                option.docCptDetail.docCptClient.mob_error = value.tel_error
                                option.docCptDetail.docCptClient.mob_num_type = value.tel_num_type
                                option.bddCtrl.getObjet(option.docCptDetail.docCptClient).mSave()
                                if (option.onValueChanged) option.onValueChanged()
                            }
                        }
                    }
                    jaugeDemarrage.mShow()
                    option.docCptDetail.mGetUrlPdfDocCpt(option.formatPrint,function (urlPdf) {
                        option.bddCtrl.mAjaxCall({
                            command: "createlinktofile",
                            url: urlPdf
                        }, function (data) {
                            var key = msEncodeInteger(data.id_link_to_file)

                            var sendSms = new cSendSms(option.bddCtrl, option.messagesms + " " + document.URLRacine + "/" + option.bddCtrl.nom_base + "/" + key + "/linkfile", false)
                            sendSms.mSendSmsMessageClientImmediat(null,value.tel_sms, function () {
                                jaugeDemarrage.mHide()
                                if (option.onEndSend) option.onEndSend()
                                mNotify("Un sms a été envoyé", "success", 8000)
                            })

                            //option.bddCtrl.mAjaxCall({
                            //    command: "sendsmsmessageclient",
                            //    tel_sms: value.tel_sms,
                            //    messagesms: option.messagesms + " " + document.URLRacine + "/" + option.bddCtrl.nom_base + "/" + key + "/linkfile"
                            //}, function (data) {
                            //    jaugeDemarrage.mHide()
                            //    if (option.onEndSend) option.onEndSend()
                            //    mNotify("Un sms a été envoyé", "success", 8000)
                            //})
                        })
                    })
                    break;
            }
            if (option.onvalide) option.onvalide(value)
        }
        mExeSendEmailSms(option)
    }

    this.mDemandeSendEmailSmsReservation = function (option) {
        var onvalide = option.onValide
        option.onValide = function (value) {
            switch (option.type) {
                case "email":
                    if (option.dataReservation.id_table_destinataire) {
                        var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.dataReservation.id_table_destinataire).nom, option.dataReservation.id_destinataire)
                        var adrEmail = obj.objetMetier.mGetAdresseEmailDefaut()
                        if (!adrEmail || adrEmail.length == 0) {
                            obj.objetMetier.mAddAdresseEmailSiVide(value)
                        }
                    }
                    if (option.bddCtrl.objCptCli.objetMetier.hasEmail()) {
                        var lstDest = []
                        if (option.dataReservation.id_destinataire) {
                            var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.dataReservation.id_table_destinataire).nom, option.dataReservation.id_destinataire)
                            var adrEmail = obj.objetMetier.mGetAdresseEmailDefaut()
                            if (adrEmail == value) {
                                lstDest = [{ id_table: option.dataReservation.id_table_destinataire, id: option.dataReservation.id_destinataire, adresse_email: value }]
                            } else {
                                lstDest = [{ id_table: null, id: null, adresse_email: value }]
                            }
                        } else {
                            lstDest = [{ id_table: null, id: null, adresse_email: value }]
                        }
                        var htmlComplementBody = option.bddCtrl.getObjet(option.dataReservation).objetMetier.mGetElementRecapitulatif().prop("outerHTML")
                        option.bddCtrl.getObjet("com_email_envoi").objetMetier.mCreateEmailBrouillon(
                            "Récapitulatif de votre réservation", html, null,
                            lstDest,
                            option.bddCtrl.paraAppli.mGetPara(option.keyParaAppli),
                            true, null, false, null, false, htmlComplementBody, function (idComEmailEnvoi) {
                                if (option.open) {
                                    option.bddCtrl.getObjet("com_email_envoi", idComEmailEnvoi).mShowPopup()
                                } else {
                                    option.bddCtrl.getObjet("com_email_envoi", idComEmailEnvoi).objetMetier.mSendImmediatement()
                                    mNotify("Un email du récapitulatif de la réservation a été envoyé à <a>" + value + "</a>", "success", 8000)
                                }
                                jaugeDemarrage.mHide()
                                option.onEndSend()
                            })
                    } else {
                        option.bddCtrl.mAjaxCall({
                            command: "sendemailmessageclient",
                            adresse_email: value,
                            keyparasignature: option.keyParaAppli,
                            html_complement_body: option.bddCtrl.getObjet(option.dataReservation).objetMetier.mGetElementRecapitulatif().prop("outerHTML")
                        }, function (data) {
                            option.onEndSend()
                            //mNotify("Un email avec le récapitulatif de la réservation a été envoyé à <a>" + dxAdrEmail.option("value") + "</a>", "success", 8000)
                        })
                    }
                    break;
                case "sms":
                    throw new Error('Not implemented');
                    //if (option.dataReservation.id_table_destinataire) {
                    //    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(objet.data.id_table_destinataire).nom, option.dataReservation.id_destinataire)
                    //    if (value.tel_num_type == "0") { //fixe
                    //    } else {
                    //        var tel = obj.objetMetier.mGetMobileDefaut()
                    //        if (!tel || tel.tel_sms.length == 0) {
                    //            obj.objetMetier.mAddTelMobileSiVide(value)
                    //        }
                    //    }
                    //}
                    //option.bddCtrl.mAjaxCall({
                    //    command: "sendsmsmessageclient",
                    //    tel_sms: value.tel_sms,
                    //    messagesms: option.message_sms + "" + urlPdf
                    //}, function (data) {
                    //    option.onEndSend()
                    //    //mNotify("Un email avec le récapitulatif de la réservation a été envoyé à <a>" + dxAdrEmail.option("value") + "</a>", "success", 8000)
                    //})
                    break;
            }
            if (onvalide) onvalide(value)
        }
        mExeSendEmailSms(option)
    }

}